<ng-template #selectionCellTemplate let-row let-column="column">
  <mat-icon *ngIf="row?.usageSelected" [color]="'primary'">check</mat-icon>
</ng-template>

<ng-template #dateCellTemplate let-row let-column="column">
  {{ row.usageUntil | date: 'dd.MM.yyyy' }}
</ng-template>
